import BaseFormItem from "../BaseFormItem";
import React from "react";
import Control from "lib/common/descriptorcontrols/DateTimeField/label";
import PropTypes from "prop-types";
import { descriptorPropTypes } from "lib/common/descriptorcontrols/formhelpers";
import ClientId from "data/ClientId";

export class Widgettimestamp extends BaseFormItem {
    render() {
        const {activeRecord, descriptor} = this.props;
        const enabled = !ClientId.is(activeRecord.id);
        let value = null;
        if (enabled) {
            const meta = activeRecord.getMetadata();
            if (descriptor.key === "ao_created_at") {
                value = meta.cts;
            } else if (descriptor.key === "ao_updated_at") {
                value = meta.ts;
            }
        }
        return <Control
            {...this.getPlumbingProps()}
            value={value}
            enabled={enabled}
        />;
    }

}

Widgettimestamp.propTypes = {
    ...Widgettimestamp.propTypes,
    descriptor: PropTypes.shape(descriptorPropTypes(null, false)),
};

export default Widgettimestamp;



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/dataentryform/formitems/Widget/timestamp.js